import { ComponentProps } from "@declarations/props";
import { linkPage } from "@utils/router";
import { useLocation, useNavigate } from "react-router-dom";
import {
  HiBuildingStorefront,
  HiCalendar,
  HiClipboardDocumentCheck,
  HiHome,
  HiListBullet,
  HiTrophy,
  HiUser,
} from "react-icons/hi2";
import { HiShoppingBag, HiShoppingCart } from "react-icons/hi";
import { useState } from "react";

export const BottomNavigation: ComponentProps<{
  type: "home" | "marketplace";
}> = ({ type = "home" }) => {
  const location = useLocation();
  const navigate = useNavigate();
  const [show, setShow] = useState<boolean>(true);

  const inputFields = document.querySelectorAll("input, textarea");

  inputFields.forEach((field) => {
    field.addEventListener("focus", () => {
      setShow(false);
    });

    field.addEventListener("blur", () => {
      setShow(true);
    });
  });

  switch (type) {
    case "home":
      return (
        <nav
          className={`navbar navbar-expand tw-bg-background-200 navbar-home ${
            !show && "navbar-hide"
          }`}
        >
          <ul className="navbar-nav nav-justified tw-w-full">
            <li className="nav-item">
              <div
                onClick={() => navigate(linkPage.HOME_DASHBOARD)}
                className={`btn-link nav-link tab ${
                  location.pathname === linkPage.HOME_DASHBOARD ? "active" : ""
                }`}
              >
                <HiHome size={21} />
                <span className="tw-text-[0.6rem] tw-font-semibold nav-name">
                  Beranda
                </span>
              </div>

              {/* <div
                onClick={() => navigate(linkPage.MARKETPLACE_PRODUCT)}
                className={`btn-link nav-link tab ${
                  location.pathname === linkPage.MARKETPLACE_PRODUCT
                    ? "active"
                    : ""
                }`}
              >
                <HiBuildingStorefront size={21} />
                <span className="tw-text-[0.6rem] tw-font-semibold nav-name">
                  Toko
                </span>
              </div> */}
              {/* 
              <div
                onClick={() => navigate("/finance/data-va")}
                className={`btn-link nav-link tab ${
                  location.pathname === "/finance/data-va" ? "active" : ""
                }`}
              >
                <HiClipboardDocumentCheck size={21} />
                <span className="tw-text-[0.6rem] tw-font-semibold nav-name">
                  Pembayaran
                </span>
              </div> */}

              <div
                onClick={() => navigate("/school/data-permit")}
                className={`btn-link nav-link tab ${
                  location.pathname === "/school/data-permit" ? "active" : ""
                }`}
              >
                <HiClipboardDocumentCheck size={21} />
                <span className="tw-text-[0.6rem] tw-font-semibold nav-name">
                  Data Izin
                </span>
              </div>

              <div
                onClick={() => navigate(linkPage.ACHIEVEMENT_PAGE)}
                className={`btn-link nav-link tab ${
                  location.pathname === linkPage.ACHIEVEMENT_PAGE
                    ? "active"
                    : ""
                }`}
              >
                <HiTrophy size={21} />
                <span className="tw-text-[0.6rem] tw-font-semibold nav-name">
                  Prestasi
                </span>
              </div>

              <div
                onClick={() => navigate(linkPage.HOME_PROFILE)}
                className={`btn-link nav-link tab ${
                  location.pathname === linkPage.HOME_PROFILE ? "active" : ""
                }`}
              >
                <HiUser size={21} />
                <span className="tw-text-[0.6rem] tw-font-semibold nav-name">
                  Profil
                </span>
              </div>
            </li>
          </ul>
        </nav>
      );
    // break;
    case "marketplace":
      return (
        <nav className="navbar navbar-expand tw-bg-background-200 navbar-marketplace">
          <ul className="navbar-nav nav-justified tw-w-full">
            <li className="nav-item">
              <div
                onClick={() => navigate(linkPage.MARKETPLACE_PRODUCT)}
                className={`btn-link nav-link tab ${
                  location.pathname === linkPage.MARKETPLACE_PRODUCT
                    ? "active"
                    : ""
                }`}
              >
                <HiShoppingBag size={21} />
                <span className="tw-text-[0.6rem] tw-font-semibold nav-name">
                  Produk
                </span>
              </div>

              <div
                onClick={() => navigate("/finance/data-va")}
                className={`btn-link nav-link tab ${
                  location.pathname === "/finance/data-va" ? "active" : ""
                }`}
              >
                <HiShoppingCart size={21} />
                <span className="tw-text-[0.6rem] tw-font-semibold nav-name">
                  Keranjang
                </span>
              </div>

              <div
                onClick={() => navigate(linkPage.HOME_PROFILE)}
                className={`btn-link nav-link tab ${
                  location.pathname === linkPage.HOME_PROFILE ? "active" : ""
                }`}
              >
                <HiListBullet size={21} />
                <span className="tw-text-[0.6rem] tw-font-semibold nav-name">
                  Pesanan
                </span>
              </div>
            </li>
          </ul>
        </nav>
      );
  }
};
